import { WidgetDefinition } from '../models/WidgetDefinition';

export const GroupsTreeWidgetDefinition: WidgetDefinition = {
    baseType: 'groupsTree',
    group: 'Charts',
    hasImage: false,
    highlights: [''],
    icon: '',
    sortingOrder: 0,
    title: 'Groups tree',
    type: 'groupsTree'
};